import moment from 'moment';
import React, { Component } from 'react';
import { Datos_Empresa, development } from "../../../libs/utils/Const";
const momentTz = require('moment-timezone');
const formatNumber = {
    separador: ',',
    sepDecimal: '.',
    formatear: function (num) {
        num += '';
        let splitStr = num.split('.');
        let splitLeft = splitStr[0];
        let splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
        let regx = /(\d+)(\d{3})/;
        while (regx.test(splitLeft)) {
            splitLeft = splitLeft.replace(regx, "$1" + this.separador + "$2");
        }
        return this.simbol + splitLeft + splitRight;
    },
    new: function (num, simbol) {
        this.simbol = simbol || '';
        if (typeof num === 'undefined' || num === null) num = 0;
        if (isNaN(num)) return num;
        return this.formatear(Number(num).toFixed(2));
    },
};

class ContrasteCobranza extends Component {
    render() {
        const { DocsToPrint, ReportsModel } = this.props;
        const doc = DocsToPrint[0];
        const { listContrasteCobranza = [], currentUser } = doc;

        const mostrarZonal = !ReportsModel?.NombreSucursal ||
            ReportsModel?.NombreSucursal === 'Todas' ||
            ReportsModel?.NombreSucursal === '';

        const totalGuia = listContrasteCobranza.reduce((acc, row) => acc + Number(row.DocTotal || 0), 0);
        const totalCobranza = listContrasteCobranza.reduce((acc, row) => acc + Number(row.PaidToDate || 0), 0);
        const totalPendiente = listContrasteCobranza.reduce((acc, row) => acc + Number(row.PorVencer || 0), 0);

        return (
            <div style={{ width: '100%', fontFamily: 'Arial', fontSize: '12px', color: '#000', padding: '15px 20px' }}>
                <div style={{ width: '100%', display: 'table', tableLayout: 'fixed', marginBottom: '10px' }}>
                    <div style={{ display: 'table-cell', width: '33.33%', verticalAlign: 'top' }}>
                        <img src={development ? require('../../../images/logo_draft.svg') : require('../../../images/logo_EMPRESA.svg')} alt="Logo" style={{ width: '60%', marginTop: '5px' }}/>
                    </div>
                    <div style={{ display: 'table-cell', width: '33.33%', textAlign: 'center', verticalAlign: 'top' }}>
                        <div style={{ fontSize: '15px', fontWeight: 'bold', marginBottom: '18px' }}>
                            Reporte de Contraste Cobranza
                        </div>
                        <div style={{ fontSize: '11px' }}>
                            Del {moment(ReportsModel.InitialDate).utc().format('DD/MM/YYYY')}
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            Al {moment(ReportsModel.FinalDate).utc().format('DD/MM/YYYY')}
                        </div>
                    </div>
                    <div style={{ display: 'table-cell', width: '33.33%', textAlign: 'right', verticalAlign: 'top', fontSize: '11px', lineHeight: '20px' }}>
                        <div>Fecha Imp : {moment().format('DD/MM/YYYY')}</div>
                        <div>Hora Imp :{' '}{momentTz().tz('America/Lima').format('hh:mm:ss a')}</div>
                        <div># Pag/ Total : 1 / 1</div>
                        <div>Usuario Imp : {currentUser?.USER_CODE || ''}</div>
                        <div>Planta : {ReportsModel?.NombrePlanta || 'Todas'}</div>
                        <div>Sucursal : {ReportsModel?.NombreSucursal || 'Todas'}</div>
                    </div>
                </div>
                <div style={{ marginBottom: '20px', fontSize: '11px', lineHeight: '24px' }}>
                    <div>Empresa: {Datos_Empresa.Nombre} {Datos_Empresa.Sociedad}</div>
                    <div>Reporte:&nbsp;<strong>R28</strong></div>
                </div>
                <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
                    <thead>
                        <tr style={{ border: '1px solid #000', height: '30px' }}>
                            {mostrarZonal &&
                                <th style={{ textAlign: 'left', width: '120px', fontWeight: 'normal', textDecoration: 'underline' }}>
                                    Sucursal
                                </th>
                            }
                            <th style={{ textAlign: 'left', paddingLeft: '6px', width: '90px', fontWeight: 'normal', textDecoration: 'underline' }}>
                                Emisión
                            </th>
                            <th style={{ textAlign: 'left', width: '105px', fontWeight: 'normal', textDecoration: 'underline' }}>
                                No. Factura
                            </th>
                            <th style={{ textAlign: 'left', width: '120px', fontWeight: 'normal', textDecoration: 'underline' }}>
                                Referencia
                            </th>
                            <th style={{ textAlign: 'left', fontWeight: 'normal', textDecoration: 'underline' }}>
                                Cliente
                            </th>
                            <th style={{ textAlign: 'right', width: '130px', paddingRight: '8px', fontWeight: 'normal', textDecoration: 'underline' }}>
                                Total Factura
                            </th>
                            <th style={{ textAlign: 'right', width: '140px', paddingRight: '8px', fontWeight: 'normal', textDecoration: 'underline' }}>
                                Total Cobrado
                            </th>
                            <th style={{ textAlign: 'right', width: '150px', paddingRight: '12px', fontWeight: 'normal', textDecoration: 'underline' }}>
                                Pendiente Cobrar
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {listContrasteCobranza.map((row, index) => (
                            <tr key={index} style={{ height: '26px', fontSize: '12px' }}>
                                {mostrarZonal &&
                                    <td style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                                        {row.NombreSucursal || '---'}
                                    </td>
                                }
                                <td style={{ paddingLeft: '8px', whiteSpace: 'nowrap' }}>
                                    {moment(row.DocDate).utc().format('DD/MM/YYYY')}
                                </td>
                                <td>{row.DocNum}</td>
                                <td style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                                    {row.NumAtCard}
                                </td>
                                <td style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                                    {row.CardName}
                                </td>
                                <td style={{ textAlign: 'right', paddingRight: '8px' }}>
                                    {formatNumber.new(row.DocTotal)}
                                </td>
                                <td style={{ textAlign: 'right', paddingRight: '8px' }}>
                                    {formatNumber.new(row.PaidToDate)}
                                </td>
                                <td style={{ textAlign: 'right', paddingRight: '12px', color: '#ee0000' }}>
                                    {formatNumber.new(row.PorVencer)}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colSpan={mostrarZonal ? 5 : 4}>
                                <div style={{ paddingTop: '8px', textAlign: 'center', fontSize: '12px' }}>
                                    <span style={{ fontSize: '11px' }}>Total General</span>
                                </div>
                            </td>
                            <td style={{ textAlign: 'right', paddingRight: '8px', fontWeight: 'bold', paddingTop: '8px' }}>
                                {formatNumber.new(totalGuia)}
                            </td>
                            <td style={{ textAlign: 'right', paddingRight: '8px', fontWeight: 'bold', paddingTop: '8px' }}>
                                {formatNumber.new(totalCobranza)}
                            </td>
                            <td style={{ textAlign: 'right', paddingRight: '12px', fontWeight: 'bold', paddingTop: '8px' }}>
                                {formatNumber.new(totalPendiente)}
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        );
    }
}

export default ContrasteCobranza;